module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/montrose-768.7bb4376524485513.jpg"+" 768w",
        images: [{path: "https://static.sniffspot.com/packs/img/montrose-768.7bb4376524485513.jpg",width: 768,height: 512}],
        src: "https://static.sniffspot.com/packs/img/montrose-768.7bb4376524485513.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/montrose-768.7bb4376524485513.jpg"},
        
        width: 768,
        height: 512
      }